import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authCfg = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// Starts the employee "Safety Tickets" PDF job and polls until done.
// Pass { employee_id } or { employee_name }. Returns the finished job (with download_url).
export async function generateEmployeeTicketsPdf({ employee_id, employee_name }, onProgress) {
  const start = await axios.post(
    `${API}/safety-cards/employee-tickets-pdf/start`,
    { employee_id, employee_name },
    authCfg()
  );
  const jobId = start.data.job_id;
  for (let i = 0; i < 120; i++) {
    await new Promise((r) => setTimeout(r, 2500));
    let j;
    try {
      const st = await axios.get(`${API}/safety-cards/employee-tickets-pdf/status/${jobId}`, authCfg());
      j = st.data;
    } catch (e) {
      continue;
    }
    if (onProgress && j.message) onProgress(j.message);
    if (j.status === 'done') {
      const token = localStorage.getItem('token');
      return {
        ...j,
        job_id: jobId,
        download_url: `${API}/safety-cards/employee-tickets-pdf/download/${jobId}?token=${encodeURIComponent(token)}`,
      };
    }
    if (j.status === 'error') throw new Error(j.error || 'Generation failed');
  }
  throw new Error('Timed out generating the PDF');
}
